/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ phone: NonNullable<unknown> }} Prices_CallInputs */

const en_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Call ${i?.phone}`)
};

const es_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Llamar al ${i?.phone}`)
};

const de_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rufen Sie ${i?.phone} an`)
};

const zh_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`致电${i?.phone}`)
};

const ar_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`اتصل على ${i?.phone}`)
};

const fr_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Appelez ${i?.phone}`)
};

const vi_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gọi ${i?.phone}`)
};

const sw_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Piga simu ${i?.phone}`)
};

const th_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`โทร ${i?.phone}`)
};

const bs_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nazovite ${i?.phone}`)
};

const ja_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`電話 ${i?.phone}`)
};

const ko_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`전화 ${i?.phone}`)
};

const pt_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ligue para ${i?.phone}`)
};

const it_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chiama ${i?.phone}`)
};

const sv_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ring ${i?.phone}`)
};

const nl_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bel ${i?.phone}`)
};

const da_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ring ${i?.phone}`)
};

const nb_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ring ${i?.phone}`)
};

const fi_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Soita ${i?.phone}`)
};

const pl_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zadzwoń do ${i?.phone}`)
};

const ru_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Позвоните: ${i?.phone}`)
};

const tr_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ara: ${i?.phone}`)
};

const hi_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.phone} पर कॉल करें`)
};

const id_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Telepon ${i?.phone}`)
};

const ms_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Telefon ${i?.phone}`)
};

const cs_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zavolejte ${i?.phone}`)
};

const el_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Καλέστε το ${i?.phone}`)
};

const he_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`התקשרו ${i?.phone}`)
};

const af_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bel ${i?.phone}`)
};

const hu_prices_call = /** @type {(inputs: Prices_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hívás: ${i?.phone}`)
};

/**
* | output |
* | --- |
* | "Call {phone}" |
*
* @param {Prices_CallInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_call = /** @type {((inputs: Prices_CallInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_CallInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_call(inputs)
	if (locale === "de") return de_prices_call(inputs)
	if (locale === "zh") return zh_prices_call(inputs)
	if (locale === "ar") return ar_prices_call(inputs)
	if (locale === "fr") return fr_prices_call(inputs)
	if (locale === "vi") return vi_prices_call(inputs)
	if (locale === "sw") return sw_prices_call(inputs)
	if (locale === "th") return th_prices_call(inputs)
	if (locale === "bs") return bs_prices_call(inputs)
	if (locale === "ja") return ja_prices_call(inputs)
	if (locale === "ko") return ko_prices_call(inputs)
	if (locale === "pt") return pt_prices_call(inputs)
	if (locale === "it") return it_prices_call(inputs)
	if (locale === "sv") return sv_prices_call(inputs)
	if (locale === "nl") return nl_prices_call(inputs)
	if (locale === "da") return da_prices_call(inputs)
	if (locale === "nb") return nb_prices_call(inputs)
	if (locale === "fi") return fi_prices_call(inputs)
	if (locale === "pl") return pl_prices_call(inputs)
	if (locale === "ru") return ru_prices_call(inputs)
	if (locale === "tr") return tr_prices_call(inputs)
	if (locale === "hi") return hi_prices_call(inputs)
	if (locale === "id") return id_prices_call(inputs)
	if (locale === "ms") return ms_prices_call(inputs)
	if (locale === "cs") return cs_prices_call(inputs)
	if (locale === "el") return el_prices_call(inputs)
	if (locale === "he") return he_prices_call(inputs)
	if (locale === "af") return af_prices_call(inputs)
	if (locale === "hu") return hu_prices_call(inputs)
	return en_prices_call(inputs)
});